import usePrivateAxios from '@/common/api/usePrivateAxios';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { MaintenanceForwardingData } from '../../types/forwardings/maintenanceForwarding.type';
import { ApiShowResponse } from '@/common/types/requests';
import { MaintenanceForwardingsDirectiveEntryKlass } from '../../types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type';
import { MaintenanceForwardingDirectiveEntryMap } from '../../types/forwardings/directiveEntries/directiveEntry.type';

type UseMaintenanceForwarding = <
  DirectiveEntry extends MaintenanceForwardingsDirectiveEntryKlass
>(forwardingId: string | undefined) => UseQueryResult<MaintenanceForwardingData<
  MaintenanceForwardingDirectiveEntryMap[DirectiveEntry]
>, unknown>;

export const useMaintenanceForwarding: UseMaintenanceForwarding = (forwardingId) => {
  const privateAxios = usePrivateAxios();

  return useQuery<ApiShowResponse<MaintenanceForwardingData>, unknown, MaintenanceForwardingData>({
    enabled: !!forwardingId,
    queryKey: ['maintenanceForwarding', forwardingId],
    queryFn: () => privateAxios.get(`/maintenance/forwardings/${forwardingId}`),
    select: (data) => data?.data?.data,
  });
}
